// @flow
import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import IconInfoThin from 'box-ui-elements/es/icons/general/IconInfoThin';

import css from './preview-disabled-header.module.scss';
import messages from './messages';

const PreviewDisabledHeader = () => {
  return (
    <div className={css.previewDisabledHeader}>
      <span className={css.previewDisabledHeaderText}>
        <IconInfoThin />
        <FormattedMessage {...messages.previewDisabledText} />
      </span>
    </div>
  );
};

export { PreviewDisabledHeader };
export default injectIntl(PreviewDisabledHeader);
